import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * DEOXY backorder notice.
 *
 * Fabric owns variant selection and section rendering. This element reads only
 * the selected variant state that Shopify has just rendered; it does not load,
 * cache or enumerate the product's variant catalogue.
 */
class DeoxyBackorder extends HTMLElement {
  #eventTarget = null;

  connectedCallback() {
    this.#eventTarget = this.closest('.shopify-section, dialog');
    this.#eventTarget?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#syncLineItemProperty(this.dataset.isBackorder === 'true');
  }

  disconnectedCallback() {
    this.#eventTarget?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #syncLineItemProperty(isBackorder) {
    const scope = this.closest('.shopify-section, dialog') || document;

    scope.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      let input = form.querySelector('[name="properties[Backorder]"]');

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Backorder]';
        form.appendChild(input);
      }

      input.value =
        this.dataset.lineProperty ||
        'This size or colour is being restocked. Order now and we’ll dispatch it within 5–7 working days.';
      input.disabled = !isBackorder;
    });
  }

  /** @param {ProductSelectEvent} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        if (detail.newProduct) {
          this.dataset.productId = String(detail.newProduct.id);
        } else if (detail.productId && String(detail.productId) !== String(this.dataset.productId)) {
          return;
        }

        const selector = `deoxy-backorder[data-block-id="${CSS.escape(this.dataset.blockId || '')}"]`;
        const replacement = detail.html.querySelector(selector);
        if (!(replacement instanceof HTMLElement)) return;

        const isBackorder = replacement.dataset.isBackorder === 'true';
        this.dataset.currentVariantId = replacement.dataset.currentVariantId || '';
        this.dataset.lineProperty = replacement.dataset.lineProperty || this.dataset.lineProperty || '';
        this.dataset.isBackorder = isBackorder ? 'true' : 'false';
        this.toggleAttribute('hidden', !isBackorder);
        this.#syncLineItemProperty(isBackorder);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[DEOXY backorder] Product selection update failed:', error);
      });
  };
}

if (!customElements.get('deoxy-backorder')) {
  customElements.define('deoxy-backorder', DeoxyBackorder);
}
